var map = {
	"./en.json": [
		1677,
		63
	],
	"./et.json": [
		1678,
		62
	],
	"./fi.json": [
		1679,
		61
	],
	"./lv.json": [
		1680,
		60
	],
	"./pl.json": [
		1681,
		59
	],
	"./ru.json": [
		1682,
		58
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1674;


//////////////////
// WEBPACK FOOTER
// ./src/i18n lazy ^\.\/.*\.json$
// module id = 1674
// module chunks = 65